import { CartLinesUpdateEvent } from '@shopify/events';

(() => {
  const ROOT = window.Shopify?.routes?.root || '/';
  const CART_SECTION = 'cart-drawer-section';

  function getButton() { return document.getElementById('sbldCtaBtn'); }
  function getOpenButton() { return document.getElementById('sbldOpenCartBtn'); }

  function readBuilderItems() {
    const builder = document.getElementById('sbld');
    const dataEl = document.getElementById('sbld-data');
    if (!builder || !dataEl) return null;

    let products;
    try { products = JSON.parse(dataEl.textContent || '[]').filter((p) => p && p.title !== null); }
    catch { return null; }

    const qty = builder.querySelector('#sbldQtyPills .sbld-pill.active')?.dataset.qty;
    const gamme = builder.querySelector('#sbldGammePills .sbld-pill.active')?.dataset.gamme;
    if (!qty || !gamme) return null;

    const slots = [...builder.querySelectorAll('#sbldSlots .sbld-slot')];
    const expected = qty === 'trio' ? 3 : 2;
    if (slots.length !== expected) return null;

    const sizeKey = gamme === 'signature' ? 'v100' : 'v50';
    const items = [];

    for (const slot of slots) {
      const title = slot.querySelector('.sbld-slot-selected-title')?.textContent?.trim();
      if (!title) return null;

      const product = products.find((p) => p.title === title);
      const variant = product?.[sizeKey];
      if (!variant?.id) return null;

      items.push({ id: Number(variant.id), quantity: 1 });
    }

    return items;
  }

  function setLoading(button) {
    if (!button) return;
    button.dataset.sensoCartBusy = 'true';
    button.disabled = true;
    button.innerHTML = 'Ajout en cours...';
  }

  function setSuccess(button) {
    if (!button) return;
    button.dataset.sensoCartBusy = 'false';
    button.disabled = false;
    button.classList.add('is-success');
    button.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5"/></svg> Ajouté au panier';
  }

  function setError(button, message) {
    if (!button) return;
    button.dataset.sensoCartBusy = 'false';
    button.disabled = false;
    button.classList.remove('is-success');
    button.innerHTML = 'Ajouter au panier';
    const msg = document.getElementById('sbldCtaMsg');
    if (msg) {
      msg.textContent = message || 'Impossible d’ajouter les parfums au panier.';
      msg.className = 'sbld-cta-msg error';
    }
  }

  async function addItems(items) {
    // Fancy's cart components listen for this event and render the returned section.
    // IMPORTANT: do not call createCartFromAjaxResponse() here. /cart/add.js does not
    // always include the currency payload that helper expects, which causes the
    // "currency code is required with currency style" error and leaves the event
    // promise pending until the theme times out.
    const deferred = CartLinesUpdateEvent.createPromise();

    document.dispatchEvent(new CartLinesUpdateEvent({
      action: 'add',
      context: 'product',
      lines: items.map((item) => ({ merchandiseId: String(item.id), quantity: Number(item.quantity || 1) })),
      promise: deferred.promise,
    }));

    try {
      const response = await fetch(
        `${ROOT}cart/add.js?sections=${encodeURIComponent(CART_SECTION)}&sections_url=${encodeURIComponent(window.location.pathname)}`,
        {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items }),
        }
      );

      const text = await response.text();
      let data = {};
      try { data = text ? JSON.parse(text) : {}; } catch { data = {}; }

      if (!response.ok) {
        throw new Error(data.description || data.message || data.errors || 'Impossible d’ajouter les parfums au panier.');
      }

      if (!data.sections?.[CART_SECTION]) {
        throw new Error('La section du panier mise à jour n’a pas été renvoyée par Shopify.');
      }

      // The Fancy theme only needs sections/items/itemCount from this event to morph
      // the cart UI and open the drawer. Avoid constructing a currency-formatted cart
      // object because the add endpoint response can omit the currency code.
      deferred.resolve({
        detail: {
          sections: data.sections,
          items: data.items || [],
          itemCount: Number(data.item_count || 0),
          source: 'senso-coffret',
          didError: false,
        },
      });

      return data;
    } catch (error) {
      deferred.reject(error);
      throw error;
    }
  }

  function openCart() {
    const drawer = document.querySelector('theme-drawer#cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
      return;
    }

    const trigger = document.querySelector('[aria-controls="cart-drawer"], [data-cart-drawer-open], .header-actions__cart');
    if (trigger) {
      trigger.click();
      return;
    }

    window.location.href = `${ROOT}cart`;
  }

  function install() {
    // Capture phase runs before the old inline Custom Liquid listener.
    // It prevents a second /cart/add.js request from the old handler.
    document.addEventListener('click', async (event) => {
      const target = event.target instanceof Element ? event.target.closest('#sbldCtaBtn') : null;
      if (!target) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      const button = getButton();
      if (!button || button.disabled || button.dataset.sensoCartBusy === 'true') return;

      const items = readBuilderItems();
      if (!items) {
        setError(button, 'Sélectionnez vos parfums.');
        return;
      }

      setLoading(button);

      try {
        await addItems(items);
        setSuccess(button);
        getOpenButton()?.classList.remove('is-hidden');
        setTimeout(() => button.classList.remove('is-success'), 1800);
      } catch (error) {
        console.error('[SENSO CART FIX]', error);
        setError(button, error?.message);
      }
    }, true);

    document.addEventListener('click', (event) => {
      const target = event.target instanceof Element ? event.target.closest('#sbldOpenCartBtn') : null;
      if (!target) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      openCart();
    }, true);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', install, { once: true });
  else install();
})();